export const ConfirmationModalConstants = {
  MODAL_HEADER: "Documents Generation",
  MAIN_TEXT: "Are you sure you want to generate the recommended documents?",
  WARNING_NOTE:
    "Note: Please do not refresh or go back while generating the document.",
  MODAL_WIDTH: "46.625rem",
};
